import React, { FC } from 'react'
import { isEqual } from 'lodash'
import { useTranslation } from 'react-i18next'
import { Action } from '../../../graphql'
import { OperationNames } from '../../../types'
import { Button, Box } from '@mui/material'

type HandleAllActionsButtonsPropsType = {
  pendingActionsList: Action[]
  isNoCheckedSignatures: boolean
  handleSignChecked: (procedureName: OperationNames | null) => void
}

const HandleAllActionsButtonsComponent: FC<HandleAllActionsButtonsPropsType> = ({
  pendingActionsList,
  isNoCheckedSignatures,
  handleSignChecked,
}) => {
  const { t } = useTranslation()

  return (
    <Box
      sx={(theme) => ({
        display: !pendingActionsList.length ? 'none' : 'flex',
        width: '100%',
        gap: theme.spacing(2),
        [theme.breakpoints.down('md')]: {
          gap: 0,
          position: 'fixed',
          bottom: 0,
          left: 0,
        },
      })}
    >
      <Button
        type="submit"
        variant="contained"
        color="secondary"
        disableElevation
        onClick={() => handleSignChecked(OperationNames.reject)}
        data-test="rejectButtonController"
        sx={{
          background: '#F5F5F5',
          color: '#000000',
          margin: 0,
          '&:hover': {
            background: '#000000',
            color: '#ffffff',
          },
        }}
      >
        {isNoCheckedSignatures
          ? t('rejectUnsigned', 'Reject unsigned')
          : t('rejectSelected', 'Reject selected')}
      </Button>
      <Button
        type="submit"
        variant="outlined"
        color="primary"
        disableElevation
        onClick={() => handleSignChecked(OperationNames.sign)}
        data-test="signButtonController"
        sx={{
          backgroundColor: 'white',
        }}
      >
        {isNoCheckedSignatures
          ? t('signUnsigned', 'Sign unsigned')
          : t('signSelected', 'Sign selected')}
      </Button>
    </Box>
  )
}

export const HandleAllActionsButtons = React.memo(HandleAllActionsButtonsComponent, isEqual)
